import { IFormatAlert } from "../IFormatAlert";
import { IFormatObjectEditable } from "../IFormatObjectEditable";
import { EmptyAlert } from "../alerts/EmptyAlert";
import { AbstractObjectsValidator } from "./AbstractObjectsValidator";
import { ElementTypes } from "../objects";

export class ObjectNameValidator extends AbstractObjectsValidator {
  protected validateObject(object: IFormatObjectEditable): IFormatAlert[] {
    if (!this.isTargetObject(object.objectTypeName().getValue())) { return; }

    if ((object.name().isEditable() && !object.name().getValue())
      || (object.hisInformationKey().isEditable() && !object.hisInformationKey().getValue())) {
      return [new EmptyAlert(object)];
    }
  }

  private isTargetObject(objectTypeName: ElementTypes): boolean {
    switch (objectTypeName) {
      case "check":
      case "combo":
      case "script":
      case "scriptlink":
      case "calculate":
      case "circleselect":
      case "roll":
      case "barcode":
      case "jointext":
      case "graph":
        return true;
      default: return false;
    }
  }
}
